import { render, staticRenderFns } from "./FooterSpNavigationAbout.vue?vue&type=template&id=26d00fe4&scoped=true"
import script from "./FooterSpNavigationAbout.vue?vue&type=script&lang=js"
export * from "./FooterSpNavigationAbout.vue?vue&type=script&lang=js"
import style0 from "./FooterSpNavigationAbout.vue?vue&type=style&index=0&id=26d00fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d00fe4",
  null
  
)

export default component.exports